import { FC } from "react";

interface DividerSVGProps {
    className?: string;
}

const DividerSVG: FC<DividerSVGProps> = (props) => {
    return (
        <svg
            className={props.className}
            width="2"
            height="18"
            viewBox="0 0 2 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path d="M1 0.5V17.5" stroke="#7A7A7E" strokeLinecap="round" />
        </svg>
    );
};

export default DividerSVG;
